/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RequestContactSettingFieldValueFromJSON, RequestContactSettingFieldValueToJSON } from './RequestContactSettingFieldValue';
export function AuthVisitorUnifiedFormSigninRequestFromJSON(json) {
    return AuthVisitorUnifiedFormSigninRequestFromJSONTyped(json, false);
}
export function AuthVisitorUnifiedFormSigninRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentId: !exists(json, 'document_id') ? undefined : json['document_id'],
        siteId: !exists(json, 'site_id') ? undefined : json['site_id'],
        contactSettingFieldValues: !exists(json, 'contact_setting_field_values')
            ? undefined
            : json['contact_setting_field_values'].map(RequestContactSettingFieldValueFromJSON)
    };
}
export function AuthVisitorUnifiedFormSigninRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_id: value.documentId,
        site_id: value.siteId,
        contact_setting_field_values: value.contactSettingFieldValues === undefined
            ? undefined
            : value.contactSettingFieldValues.map(RequestContactSettingFieldValueToJSON)
    };
}
